/* eslint no-underscore-dangle: off */
import React from 'react';
import ReactDOM from 'react-dom';
import MobileDetect from 'mobile-detect';

import { renderRoutes } from 'react-router-config';
import { BrowserRouter } from 'react-router-dom';
import routes from './app/routes';

const mobileDetect = new MobileDetect(window.navigator.userAgent);
const isMobile = Boolean(mobileDetect.mobile());
const config = { ...window.__SEO_CONFIG__, isMobile };

// eslint-disable-next-line prettier/prettier
const App = <BrowserRouter>{renderRoutes(routes, { config })}</BrowserRouter>;

ReactDOM[module.hot ? 'render' : 'hydrate'](App, document.getElementById('root'));
